import { SearchParameterToQuery } from '../constants';

// these are "internal use" query params that are sent to search-service but
// are not meant to be deeplinkable as query parameters
export const IGNORED_PARAMS = Object.freeze([
    'directoryId',
    'excludeSpecialties',
    'pickerErrorOverride',
    'practiceId',
    'scopeToCoordinates',
]);

export default function formQueryObject(searchParams) {
    return Object.keys(searchParams).reduce((queryMap, param) => {
        if (IGNORED_PARAMS.indexOf(param) === -1) {
            queryMap[SearchParameterToQuery[param]] = searchParams[param];
        }

        return queryMap;
    }, {});
}
